<div class="form-control-autocomplete">
  <ng-autocomplete
    [data]="items"
    [searchKeyword]="searchItem"
    [initialValue]='initialVal'
    [placeholder]="title"
    [selectedValueRender]="selectedValueRenderFn"
    (selected)="onItemChange($event)"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    (inputChanged)='onChangeSearch($event)'
    (scrolledToEnd)="scrollToEnd()"
    [minQueryLength]="1"
    [debounceTime]="600"
    (inputCleared)="searchCleared()"
    [isLoading]="isLoading"
    [disabled]="disabled"
    #autocomplete
  >
  </ng-autocomplete>

  <ng-template #itemTemplate let-item>
    <a *ngIf="!item?.parent_id" [innerHTML]="item.label"></a>
    <a *ngIf="item?.parent_id && item?.parent_id!==null" class="fs-7 ms-6 p-1" [innerHTML]="item.label"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div>
      {{"noResults" | translate}}
    </div>
  </ng-template>
</div>
